if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      
        const overlay = document.querySelector('.overlayermodal');
        if (overlay) {
          overlay.addEventListener('click', () => {
            this.hide();
          });
        }
      
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.hide();
          }
        });
      
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      
        setTimeout(() => {
          this.modalContent.innerHTML = '';
        }, 500);
      
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const originalUrl = opener.getAttribute('data-product-url');

        // Zuerst Produktdaten laden
        const newUrl = this.shortenUrl(originalUrl);
        fetch(newUrl)
          .then((response) => response.json())
          .then(product => {
            this.productData = product;
            
            // SOFORT Bild preloaden während HTML geladen wird
            this.preloadProductImage();
            
            // Dann HTML laden
            return fetch(originalUrl);
          })
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            const cleanHTML = this.buildCleanModalHTML(productElement);
            this.modalContent.innerHTML = cleanHTML;

            productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });

            initializeSwipers();
            initializeSliderButtons();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Bild SOFORT laden, bevor Modal geöffnet wird
            this.loadInitialImage();
            this.findMatchingVariant();

            super.show(opener);

            this.setupMutationObserver();
            this.addVariantChangeListeners();
            this.fixQuantityBreaksInModal();
            this.fixNormalAddToCartButton();
          })
          .catch(error => {
            console.error('Fehler beim Laden:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      buildCleanModalHTML(sourceElement) {
        const sectionId = sourceElement.dataset.section;
        const newId = `quickadd-${sectionId}`;
        
        const mediaWrapper = sourceElement.querySelector('.product__media-wrapper');
        const productTitle = sourceElement.querySelector('.product__title');
        const productPrice = sourceElement.querySelector('.product__price');
        const masterSelect = sourceElement.querySelector('.masterselect');
        const taxInfo = sourceElement.querySelector('.product__tax');
        const installmentForm = sourceElement.querySelector('form[id*="product-form-installment"]');
        const variantSelects = sourceElement.querySelector('variant-selects');
        const quantityBreaks = sourceElement.querySelector('quantity-breaks');
        const productForm = sourceElement.querySelector('product-form');
        const viewDetailsLink = sourceElement.querySelector('a[class*="product__view-details"]');
        
        const stylesheets = sourceElement.querySelectorAll('link[rel="stylesheet"]');
        const inlineStyles = sourceElement.querySelectorAll('style');
        const scripts = sourceElement.querySelectorAll('script');

        let cleanHTML = `
          <product-info id="MainProduct-${newId}" 
                       class="${sourceElement.className}" 
                       data-section="${newId}" 
                       data-product-id="${sourceElement.dataset.productId}" 
                       data-update-url="false" 
                       data-url="${sourceElement.dataset.url}" 
                       data-original-section="${sectionId}">
        `;

        stylesheets.forEach(stylesheet => {
          cleanHTML += this.updateIDs(stylesheet.outerHTML, sectionId, newId);
        });

        inlineStyles.forEach(style => {
          cleanHTML += this.updateIDs(style.outerHTML, sectionId, newId);
        });

        scripts.forEach(script => {
          cleanHTML += this.updateIDs(script.outerHTML, sectionId, newId);
        });

        cleanHTML += `      
          <div class="page-width">
            <div class="product product--medium product--left product--thumbnail product--mobile-hide grid--2-col-tablet">
        `;

        if (mediaWrapper) {
          cleanHTML += `<div class="product__media-wrapper">`;
          
          const variantImageContainer = mediaWrapper.querySelector('.variant-image-container');
          if (variantImageContainer) {
            cleanHTML += variantImageContainer.outerHTML;
          }
          
          cleanHTML += `<div class="product__info-container">`;
          if (productTitle) {
            cleanHTML += this.updateIDs(productTitle.outerHTML, sectionId, newId);
          }
          if (productPrice) {
            cleanHTML += this.updateIDs(productPrice.outerHTML, sectionId, newId);
          }
          cleanHTML += `</div>`;
          
          cleanHTML += `</div>`;
        }

        cleanHTML += `<div class="product__info-wrapper scroll-trigger animate--slide-in">
                       <section id="ProductInfo-${newId}" class="product__info-container product__column-sticky">`;

        if (masterSelect) {
          cleanHTML += this.updateIDs(masterSelect.outerHTML, sectionId, newId);
        }
        if (taxInfo) {
          cleanHTML += this.updateIDs(taxInfo.outerHTML, sectionId, newId);
        }
        if (installmentForm) {
          cleanHTML += this.updateIDs(installmentForm.outerHTML, sectionId, newId);
        }
        if (variantSelects) {
          cleanHTML += this.updateIDs(variantSelects.outerHTML, sectionId, newId);
        }
        if (quantityBreaks) {
          cleanHTML += this.updateIDs(quantityBreaks.outerHTML, sectionId, newId);
        }
        if (productForm) {
          cleanHTML += this.updateIDs(productForm.outerHTML, sectionId, newId);
        }
        if (viewDetailsLink) {
          cleanHTML += this.updateIDs(viewDetailsLink.outerHTML, sectionId, newId);
        }

        cleanHTML += `    </section>
                         </div>
                       </div>
                     </div>
                   </product-info>`;

        return cleanHTML;
      }

      updateIDs(htmlString, oldId, newId) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        
        const sizeGuideElements = tempDiv.querySelectorAll('.sizeguide-container');
        sizeGuideElements.forEach(element => element.remove());
        
        return tempDiv.innerHTML.replaceAll(oldId, newId);
      }

      preloadProductImage() {
        if (!this.productData) return;
        
        let imageUrl = null;
        
        if (this.productData.featured_image?.src) {
          imageUrl = this.productData.featured_image.src;
        } else if (this.productData.featured_media?.src) {
          imageUrl = this.productData.featured_media.src;
        } else if (this.productData.images && this.productData.images.length > 0) {
          imageUrl = this.productData.images[0].src || this.productData.images[0];
        }

        if (imageUrl) {
          const smallImageUrl = imageUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1');
          
          // Bild preloaden
          const preloadImg = new Image();
          preloadImg.src = smallImageUrl;
          
          // Speichere URL für späteren Gebrauch
          this.preloadedImageUrl = smallImageUrl;
        }
      }

      loadInitialImage() {
        if (!this.productData) return;

        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;

        // Verwende bereits pregeladene URL wenn verfügbar
        let imageUrl = this.preloadedImageUrl;
        
        if (!imageUrl) {
          // Fallback falls preload nicht funktioniert hat
          let originalUrl = null;
          if (this.productData.featured_image?.src) {
            originalUrl = this.productData.featured_image.src;
          } else if (this.productData.featured_media?.src) {
            originalUrl = this.productData.featured_media.src;
          } else if (this.productData.images && this.productData.images.length > 0) {
            originalUrl = this.productData.images[0].src || this.productData.images[0];
          }
          
          if (originalUrl) {
            imageUrl = originalUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1');
          }
        }

        if (imageUrl) {
          let imageContainer = mediaWrapper.querySelector('.variant-image-container');
          if (!imageContainer) {
            imageContainer = document.createElement('div');
            imageContainer.classList.add('variant-image-container');
            
            if (mediaWrapper.firstChild) {
              mediaWrapper.insertBefore(imageContainer, mediaWrapper.firstChild);
            } else {
              mediaWrapper.appendChild(imageContainer);
            }
          }

          let imgElement = imageContainer.querySelector('img');
          if (!imgElement) {
            imgElement = document.createElement('img');
            imageContainer.appendChild(imgElement);
          }

          // Bild sofort setzen (sollte bereits gecacht sein)
          imgElement.src = imageUrl;
          imgElement.alt = this.productData.title;
          imgElement.style.width = '100%';
          imgElement.style.height = 'auto';
          imgElement.style.objectFit = 'cover';
        }
      }

      addVariantChangeListeners() {
        const radioButtons = this.modalContent.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
          radio.addEventListener('change', () => {
            this.findMatchingVariant();
          });
        });

        const quantityBreaksRadios = this.modalContent.querySelectorAll('input[name="quantity"]');
        quantityBreaksRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            this.handleQuantityBreakChange();
          });
        });

        const comboBoxButtons = this.modalContent.querySelectorAll('.combo-box__option-item');
        comboBoxButtons.forEach(button => {
          button.addEventListener('click', () => {
            setTimeout(() => {
              this.handleQuantityBreakVariantChange(button);
            }, 100);
          });
        });
      }

      setupMutationObserver() {
        const modalContainer = this.modalContent;
        let debounceTimeout;

        const observer = new MutationObserver((mutations) => {
          let hasChanged = false;

          mutations.forEach(mutation => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              hasChanged = true;
            }
          });

          if (hasChanged) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
              this.addVariantChangeListeners();
            }, 300);
          }
        });

        observer.observe(modalContainer, {
          childList: true,
          subtree: true
        });
      }

      shortenUrl(url) {
        return url.split('?')[0] + '.js';
      }

      findMatchingVariant() {
        const selectedOptions = Array.from(this.modalContent.querySelectorAll('input[type="radio"]:checked'))
          .map(input => input.value.trim());

        if (selectedOptions.length === 0) return;

        const matchingVariant = this.productData.variants.find(variant => {
          return selectedOptions.every((option, index) => variant.options[index] === option);
        });

        if (matchingVariant) {
          const productForm = this.modalContent.querySelector('product-form form');
          const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
          
          if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
          }

          const variantImageUrl = matchingVariant.featured_image?.src;

          if (variantImageUrl) {
            const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');

            if (mediaWrapper) {
              let newImageDiv = mediaWrapper.querySelector('.variant-image-container');
              if (!newImageDiv) {
                newImageDiv = document.createElement('div');
                newImageDiv.classList.add('variant-image-container');
              }

              let imgElement = newImageDiv.querySelector('img');
              if (!imgElement) {
                imgElement = document.createElement('img');
                newImageDiv.appendChild(imgElement);
              }

              const smallImageUrl = variantImageUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1');
              imgElement.src = smallImageUrl;
              imgElement.alt = `Variante: ${matchingVariant.title}`;
              imgElement.style.width = '100%';
              imgElement.style.height = 'auto';
              imgElement.style.objectFit = 'cover';

              if (mediaWrapper.firstChild) {
                mediaWrapper.insertBefore(newImageDiv, mediaWrapper.firstChild);
              } else {
                mediaWrapper.appendChild(newImageDiv);
              }
            }
          }
        }
      }

      // Für normale Produkte ohne Quantity Breaks
      fixNormalAddToCartButton() {
        const quantityBreaks = this.modalContent.querySelector('quantity-breaks');
        if (quantityBreaks) return; // Wenn Quantity Breaks vorhanden sind, nichts machen
        
        const addToCartButton = this.modalContent.querySelector('button[type="submit"]');
        if (!addToCartButton) return;
        
        // Event Listener für normalen Add to Cart Button
        addToCartButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const productForm = this.modalContent.querySelector('product-form form');
          if (!productForm) return;
          
          const formData = new FormData(productForm);
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity')) || 1;
          
          if (variantId) {
            this.addItemsToCart([{ id: variantId, quantity: quantity }]);
          }
        });
      }

      // Für Quantity Breaks Produkte
      fixQuantityBreaksInModal() {
        const quantityInputs = Array.from(this.modalContent.querySelectorAll('input[name="quantity"]'));
        const quantityLabels = Array.from(this.modalContent.querySelectorAll('.quantity-break'));

        // Nur ausführen wenn Quantity Breaks vorhanden sind
        if (quantityInputs.length === 0 || quantityLabels.length === 0) return;

        quantityInputs.forEach((input, index) => {
          const label = quantityLabels[index];
          if (label) {
            input.style.position = 'absolute';
            input.style.opacity = '0';
            input.style.width = '0';
            input.style.height = '0';
            input.style.cursor = 'pointer';

            label.addEventListener('click', (e) => {
              e.preventDefault();
              
              quantityInputs.forEach(otherInput => otherInput.checked = false);
              input.checked = true;
              
              quantityLabels.forEach(otherLabel => otherLabel.classList.remove('selected'));
              label.classList.add('selected');
              
              this.handleQuantityBreakChange();
            });
          }
        });

        if (quantityInputs.length > 0 && !quantityInputs.some(input => input.checked)) {
          quantityInputs[0].checked = true;
          quantityLabels[0]?.classList.add('selected');
        }

        this.initializeComboBoxes();
        this.fixAddToCartButton();
      }

      fixAddToCartButton() {
        const addToCartButton = this.modalContent.querySelector('button[type="submit"]');
        const overButton = this.modalContent.querySelector('.over-button');
        
        if (overButton) {
          overButton.style.display = 'none';
          overButton.style.pointerEvents = 'none';
        }
        
        if (addToCartButton) {
          addToCartButton.style.pointerEvents = 'all';
          addToCartButton.style.zIndex = '10';
          addToCartButton.style.position = 'relative';
          
          const existingHandlers = addToCartButton.cloneNode(true);
          addToCartButton.parentNode.replaceChild(existingHandlers, addToCartButton);
          
          existingHandlers.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            this.handleQuantityBreakAddToCart();
          });
        }
      }

      handleQuantityBreakChange() {
        const checkedQuantityBreak = this.modalContent.querySelector('input[name="quantity"]:checked');
        if (!checkedQuantityBreak) return;

        const quantityLabel = this.modalContent.querySelector(`label[for="${checkedQuantityBreak.id}"]`);
        if (!quantityLabel) return;

        const firstSelectorItem = quantityLabel.querySelector('.quantity-break__selector-item');
        if (firstSelectorItem) {
          this.updateImageFromQuantityBreakSelector(firstSelectorItem);
        }
      }

      handleQuantityBreakVariantChange(clickedButton) {
        const selectorItem = clickedButton.closest('.quantity-break__selector-item');
        if (selectorItem) {
          this.updateImageFromQuantityBreakSelector(selectorItem);
        }
      }

      updateImageFromQuantityBreakSelector(selectorItem) {
        const selectedValues = Array.from(selectorItem.querySelectorAll('.select__selected-value'))
          .map(span => span.textContent.trim())
          .filter(val => val !== '');

        const variantTitle = selectedValues.join(' / ');
        
        const matchingVariant = this.productData.variants.find(variant => {
          return variant.title === variantTitle;
        });

        if (matchingVariant) {
          this.updateVariantImage(matchingVariant);
          this.updateVariantId(matchingVariant.id);
        }
      }

      updateVariantImage(variant) {
        if (!variant.featured_image) return;
        
        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;

        let imageContainer = mediaWrapper.querySelector('.variant-image-container');
        if (!imageContainer) {
          imageContainer = document.createElement('div');
          imageContainer.classList.add('variant-image-container');
          
          if (mediaWrapper.firstChild) {
            mediaWrapper.insertBefore(imageContainer, mediaWrapper.firstChild);
          } else {
            mediaWrapper.appendChild(imageContainer);
          }
        }

        let imgElement = imageContainer.querySelector('img');
        if (!imgElement) {
          imgElement = document.createElement('img');
          imageContainer.appendChild(imgElement);
        }

        const smallImageUrl = variant.featured_image.src.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1');
        imgElement.src = smallImageUrl;
        imgElement.alt = `Variante: ${variant.title}`;
        imgElement.style.width = '100%';
        imgElement.style.height = 'auto';
        imgElement.style.objectFit = 'cover';
      }

      updateVariantId(variantId) {
        const productForm = this.modalContent.querySelector('product-form form');
        const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
        
        if (variantIdInput) {
          variantIdInput.value = variantId;
        }
      }

      handleQuantityBreakAddToCart() {
        const checkedQuantityBreak = this.modalContent.querySelector('input[name="quantity"]:checked');
        if (!checkedQuantityBreak) return;

        const quantityLabel = this.modalContent.querySelector(`label[for="${checkedQuantityBreak.id}"]`);
        if (!quantityLabel) return;

        const totalQuantity = parseInt(quantityLabel.getAttribute('data-quantity')) || 1;
        const selectorItems = quantityLabel.querySelectorAll('.quantity-break__selector-item');
        const masterSelect = this.modalContent.querySelector('#master-select');
        const itemsToAdd = [];

        if (selectorItems.length > 0) {
          selectorItems.forEach((selectorItem) => {
            const selectedValues = Array.from(selectorItem.querySelectorAll('.select__selected-value'))
              .map(span => span.textContent.trim())
              .filter(val => val !== '');

            const variantTitle = selectedValues.join(' / ');
            let matchingVariantId = null;

            if (masterSelect) {
              for (const option of masterSelect.options) {
                if (option.textContent.trim() === variantTitle) {
                  matchingVariantId = option.value;
                  break;
                }
              }
            }

            if (matchingVariantId) {
              itemsToAdd.push({ id: matchingVariantId, quantity: 1 });
            }
          });
        } else {
          const productForm = this.modalContent.querySelector('product-form form');
          const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
          const defaultVariantId = variantIdInput ? variantIdInput.value : (masterSelect ? masterSelect.options[0].value : null);
          
          if (defaultVariantId) {
            itemsToAdd.push({ id: defaultVariantId, quantity: totalQuantity });
          }
        }

        if (itemsToAdd.length > 0) {
          this.addItemsToCart(itemsToAdd);
        }
      }

      addItemsToCart(items) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Fehler beim Hinzufügen zum Warenkorb');
          return response.json();
        })
        .then(() => {
          return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
        })
        .then(res => res.json())
        .then(sections => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.renderContents) {
            cartDrawer.renderContents({ sections: sections });
          }
          
          // is-empty Klasse von cart-drawer und drawer__inner entfernen
          const cartDrawerElement = document.querySelector('cart-drawer');
          if (cartDrawerElement && cartDrawerElement.classList.contains('is-empty')) {
            cartDrawerElement.classList.remove('is-empty');
          }
          
          const drawerInner = document.querySelector('.drawer__inner');
          if (drawerInner && drawerInner.classList.contains('is-empty')) {
            drawerInner.classList.remove('is-empty');
          }
          
          this.hide();
          
          if (cartDrawerElement && cartDrawerElement.open) {
            cartDrawerElement.open();
          }
        })
        .catch(err => {
          console.error('Fehler beim Hinzufügen zum Warenkorb:', err);
        });
      }

      initializeComboBoxes() {
        const comboBoxes = this.modalContent.querySelectorAll('combo-box');
        
        comboBoxes.forEach((comboBox, index) => {
          const toggleButton = comboBox.parentElement.querySelector('.select');
          const optionItems = comboBox.querySelectorAll('.combo-box__option-item');
          const hiddenSelect = comboBox.querySelector('select');
          const selectedValueSpan = toggleButton?.querySelector('.select__selected-value');

          if (toggleButton) {
            toggleButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
              
              this.modalContent.querySelectorAll('combo-box').forEach(otherBox => {
                const otherToggle = otherBox.parentElement.querySelector('.select');
                if (otherToggle) {
                  otherToggle.setAttribute('aria-expanded', 'false');
                  otherBox.style.display = 'none';
                }
              });
              
              if (!isExpanded) {
                toggleButton.setAttribute('aria-expanded', 'true');
                comboBox.style.display = 'block';
                comboBox.style.position = 'absolute';
                comboBox.style.zIndex = '9999';
                comboBox.style.background = 'white';
                comboBox.style.border = '1px solid #ccc';
                comboBox.style.borderRadius = '4px';
                comboBox.style.maxHeight = '200px';
                comboBox.style.overflow = 'auto';
                comboBox.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
              }
            });
          }

          optionItems.forEach(item => {
            item.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const value = item.getAttribute('value');
              const isDisabled = item.classList.contains('disabled');
              
              if (isDisabled) return;

              optionItems.forEach(otherItem => {
                otherItem.setAttribute('aria-selected', 'false');
              });
              
              item.setAttribute('aria-selected', 'true');
              
              if (hiddenSelect) {
                hiddenSelect.value = value;
                hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
              
              if (selectedValueSpan) {
                const colorSwatch = item.querySelector('.combo-box__color-swatch');
                const existingSwatch = selectedValueSpan.querySelector('.select__color-swatch');
                
                if (colorSwatch && existingSwatch) {
                  existingSwatch.setAttribute('style', colorSwatch.getAttribute('style'));
                  existingSwatch.setAttribute('aria-label', colorSwatch.getAttribute('aria-label'));
                }
                
                const textNodes = Array.from(selectedValueSpan.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
                if (textNodes.length > 0) {
                  textNodes[textNodes.length - 1].nodeValue = value;
                } else {
                  selectedValueSpan.appendChild(document.createTextNode(value));
                }
              }
              
              if (toggleButton) {
                toggleButton.setAttribute('aria-expanded', 'false');
              }
              comboBox.style.display = 'none';
              
              setTimeout(() => {
                this.handleQuantityBreakVariantChange(item);
              }, 50);
            });
          });

          const closeButton = comboBox.querySelector('.combo-box__close-button');
          if (closeButton) {
            closeButton.addEventListener('click', (e) => {
              e.preventDefault();
              if (toggleButton) {
                toggleButton.setAttribute('aria-expanded', 'false');
              }
              comboBox.style.display = 'none';
            });
          }
        });

        document.addEventListener('click', (e) => {
          if (!e.target.closest('combo-box') && !e.target.closest('.select')) {
            comboBoxes.forEach(comboBox => {
              const toggleButton = comboBox.parentElement.querySelector('.select');
              if (toggleButton) {
                toggleButton.setAttribute('aria-expanded', 'false');
              }
              comboBox.style.display = 'none';
            });
          }
        });
      }

      preprocessHTML(productElement) {
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}